import { IDmSnsMsgSetting } from '@blcloud/bl-datamodel';
import { ISurveyGuideLabelValue } from '@blcloud/bl-ng-share-module';

/** DMSNSメッセージ本文タイプ */
export enum DmSnsMsgBodyType {
  /** テキスト */
  Text = '0',
  /** 画像 */
  Image = '1',
  /** フレックスメッセージ */
  FlexMessage = '2',
  /** アンケート */
  Survey = '3'
}

/** アンケート情報を含むDMSNSメッセージ設定 */
export interface IDmSnsMsgSettingEx extends IDmSnsMsgSetting {
  /** アンケート名 */
  surveyName?: string | null;
}

/** コンテキストメニュー */
export enum ContextMenu {
  /** 追加 */
  Add,
  /** 削除 */
  Delete,
  /** 上移動 */
  Up,
  /** 下移動 */
  Down
}

/** DMSNSメッセージ設定拡張 */
export interface DmSnsMsgSettingEx {
  /** DMSNSメッセージ設定 */
  dmSnsMsgSetting: IDmSnsMsgSettingEx;
  /** ファイル */
  file: File | null;
  /** 件名文字数カウント */
  titleCount: number;
  /** 件名スタイルフラグ */
  isTitleStyleDisabled: boolean;
  /** 件名2文字数カウント */
  title2Count: number;
  /** 件名2スタイルフラグ */
  isTitle2StyleDisabled: boolean;
  /** 件名3文字数カウント */
  title3Count: number;
  /** 件名3スタイルフラグ */
  isTitle3StyleDisabled: boolean;
  /** 本文文字数カウント */
  count: number;
  /** 本文スタイルフラグ */
  isStyleDisabled: boolean;
  /** 表示用LINEメッセージテンプレート名称 */
  dispLineMsgTemplateName: string;
  /** LINEメッセージテンプレート画像URL */
  lineMsgTemplateImageUrl: string;
  /** フレックスメッセージに件名設定可能か */
  isEnabledSetTitleInFlex: boolean;
  /** フレックスメッセージに件名2設定可能か */
  isEnabledSetTitle2InFlex: boolean;
  /** フレックスメッセージに件名3設定可能か */
  isEnabledSetTitle3InFlex: boolean;
  /** フレックスメッセージにラベル設定可能か */
  isEnabledSetLabelInFlex: boolean;
  /** フレックスメッセージにラベル2設定可能か */
  isEnabledSetLabel2InFlex: boolean;
  /** フレックスメッセージに本文設定可能か */
  isEnabledSetBodyInFlex: boolean;
  /** フレックスメッセージにフッター設定可能か */
  isEnabledSetFooterInFlex: boolean;
  /** フレックスメッセージにフッター2設定可能か */
  isEnabledSetFooter2InFlex: boolean;
  /** フレックスメッセージに画像設定可能か */
  isEnabledSetImageInFlex: boolean;
  /** テキストメッセージ本文入力エリア最終選択開始位置 */
  normalTextInputViewLastSelectionStart: number;
  /** テキストメッセージ本文入力エリア最終選択終了位置 */
  normalTextInputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名入力エリア最終選択開始位置 */
  flexTitleInputViewLastSelectionStart: number;
  /** フレックスメッセージ件名入力エリア最終選択終了位置 */
  flexTitleInputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名2入力エリア最終選択開始位置 */
  flexTitle2InputViewLastSelectionStart: number;
  /** フレックスメッセージ件名2入力エリア最終選択終了位置 */
  flexTitle2InputViewLastSelectionEnd: number;
  /** フレックスメッセージ件名3入力エリア最終選択開始位置 */
  flexTitle3InputViewLastSelectionStart: number;
  /** フレックスメッセージ件名3入力エリア最終選択終了位置 */
  flexTitle3InputViewLastSelectionEnd: number;
  /** フレックスメッセージラベル入力エリア最終選択開始位置 */
  flexLabelInputViewLastSelectionStart: number;
  /** フレックスメッセージラベル入力エリア最終選択終了位置 */
  flexLabelInputViewLastSelectionEnd: number;
  /** フレックスメッセージラベル2入力エリア最終選択開始位置 */
  flexLabel2InputViewLastSelectionStart: number;
  /** フレックスメッセージラベル2入力エリア最終選択終了位置 */
  flexLabel2InputViewLastSelectionEnd: number;
  /** フレックスメッセージフッター入力エリア最終選択開始位置 */
  flexFooterInputViewLastSelectionStart: number;
  /** フレックスメッセージフッター入力エリア最終選択終了位置 */
  flexFooterInputViewLastSelectionEnd: number;
  /** フレックスメッセージフッター2入力エリア最終選択開始位置 */
  flexFooter2InputViewLastSelectionStart: number;
  /** フレックスメッセージフッター2入力エリア最終選択終了位置 */
  flexFooter2InputViewLastSelectionEnd: number;
  /** フレックスメッセージ本文入力エリア最終選択開始位置 */
  flexTextInputViewLastSelectionStart: number;
  /** フレックスメッセージ本文入力エリア最終選択終了位置 */
  flexTextInputViewLastSelectionEnd: number;
  /** 選択中のアンケート */
  survey?: ISurveyGuideLabelValue;
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/content/sns-send-message-content.interface.ts